import {Model} from "../../_model/Model";
import type {IModelDto} from "../../_model/model.dto";
import type {IEntityDto} from "./entity.dto";

export default abstract class EntityModel extends Model {
    public ID = "";
    public version = 0;

    public mapToDto(): IModelDto {
        const dto: IEntityDto = {
            ID: this.ID,
            version: this.version
        };
        return dto;
    }
}
